// Shared bits of the step components.

import type { ReactNode } from 'react'
import type { WizardController } from '../useWizard'
import { T } from '../styles'

export interface StepProps {
  ctl: WizardController
  handheld: boolean
}

export function Help({ children }: { children: ReactNode }) {
  if (!children) return null
  return <div style={{ color: T.muted, fontSize: 14, lineHeight: 1.45 }}>{children}</div>
}

export function Check({ checked, onChange, label, handheld, hook }: {
  checked: boolean
  onChange: (v: boolean) => void
  label: string
  handheld: boolean
  hook?: string
}) {
  return (
    <label style={{
      display: 'flex', alignItems: 'center', gap: 10, minHeight: handheld ? 48 : 32, cursor: 'pointer',
      fontSize: handheld ? 16 : 14,
    }} data-tw-field={hook}>
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)}
        style={{ width: handheld ? 22 : 16, height: handheld ? 22 : 16 }} />
      <span>{label}</span>
    </label>
  )
}

export function display(v: unknown): string {
  if (v === null || v === undefined) return ''
  if (typeof v === 'boolean') return v ? 'Yes' : 'No'
  if (typeof v === 'object') return JSON.stringify(v)
  return String(v)
}
